/**
 * Broadcast Utils
 * Funções utilitárias do módulo de broadcast
 */

/**
 * Obtém o conteúdo do broadcast (compatibilidade com formatos antigo e novo)
 */
export const getBroadcastContent = (broadcast) => {
	const pushTitle = broadcast.push?.title || broadcast.title || ''
	const pushBody = broadcast.push?.body || broadcast.message || ''
	const emailSubject = broadcast.email?.subject || broadcast.title || ''
	const emailTitle = broadcast.email?.title || ''
	const emailBody = broadcast.email?.body || broadcast.message || ''

	return { pushTitle, pushBody, emailSubject, emailTitle, emailBody }
}

/**
 * Valida o formulário de broadcast
 */
export const validateBroadcastForm = (form) => {
	const errors = []

	if (form.type === 'push' || form.type === 'both') {
		if (!form.pushTitle) errors.push('Título do Push é obrigatório')
		if (!form.pushMessage) errors.push('Mensagem do Push é obrigatória')
	}

	if (form.type === 'email' || form.type === 'both') {
		if (!form.emailSubject) errors.push('Assunto do Email é obrigatório')
		if (!form.emailTitle) errors.push('Título do Email é obrigatório')
		if (!form.emailBody) errors.push('Corpo do Email é obrigatório')
	}

	if (form.targetAudience === 'custom' && form.customUserIds.length === 0) {
		errors.push('Selecione pelo menos um usuário')
	}

	return errors
}

/**
 * Monta o payload para envio/preview do broadcast
 */
export const buildBroadcastPayload = (form) => {
	const payload = {
		type: form.type,
		targetAudience: form.targetAudience,
		customUserIds: form.customUserIds,
		filters: form.filters,
	}

	if (form.type === 'push' || form.type === 'both') {
		payload.push = {
			title: form.pushTitle,
			body: form.pushMessage,
		}
	}

	if (form.type === 'email' || form.type === 'both') {
		payload.email = {
			subject: form.emailSubject,
			title: form.emailTitle,
			body: form.emailBody,
		}
	}

	return payload
}

/**
 * Monta o payload para reenvio do broadcast
 */
export const buildResendPayload = (broadcast, resendForm) => {
	const payload = {
		type: broadcast.type,
		targetAudience: resendForm.targetAudience,
		customUserIds: resendForm.customUserIds,
	}

	if (broadcast.type === 'push' || broadcast.type === 'both') {
		payload.push = broadcast.push || {
			title: broadcast.title,
			body: broadcast.message,
		}
	}

	if (broadcast.type === 'email' || broadcast.type === 'both') {
		payload.email = broadcast.email || {
			subject: broadcast.title,
			body: broadcast.message,
		}
	}

	return payload
}
